// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 3px var(--shadow-color);
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
}

.logo {
  color: var(--accent-primary);
  font-size: 1.2rem;
  font-weight: bold;
  text-decoration: none;
}

.logo h1 {
  margin: 0;
  font-size: 1.5rem;
}

.nav {
  display: flex;
  gap: 20px;
  align-items: center;
}

.nav-link {
  color: var(--text-primary);
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 20px;
  transition: background 0.2s;
}

.nav-link:hover {
  background: var(--bg-tertiary);
  text-decoration: none;
}

/* Dropdown Styles */
.dropdown {
  position: relative;
}

.dropdown-toggle {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: 0 4px 16px var(--shadow-color);
  min-width: 150px;
  overflow: hidden;
  z-index: 1000;
}

.dropdown-item {
  display: block;
  padding: 12px 16px;
  color: var(--text-primary);
  text-decoration: none;
  transition: background 0.2s;
  font-weight: 500;
}

.dropdown-item:hover {
  background: var(--bg-tertiary);
  text-decoration: none;
}

.auth-section {
  position: relative;
}

.user-menu {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Account Dropdown Styles */
.account-dropdown {
  position: relative;
}

.avatar-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  border-radius: 50%;
  transition: opacity 0.2s;
}

.avatar-btn:hover {
  opacity: 0.8;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--border-color);
}

.account-dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: 0 4px 16px var(--shadow-color);
  min-width: 200px;
  overflow: hidden;
  z-index: 1000;
}

.account-dropdown-header {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color);
  font-weight: 600;
  font-size: 14px;
  color: var(--text-secondary);
}

.account-dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  text-align: left;
  font-size: 14px;
  color: var(--text-primary);
}

.account-dropdown-item:hover {
  background: var(--bg-tertiary);
}

.account-dropdown-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.add-account-btn {
  border-top: 1px solid var(--border-color);
  font-weight: 600;
  color: var(--accent-primary);
  justify-content: center;
}

.add-account-btn:hover {
  background: var(--accent-light);
}

.account-dropdown-divider {
  height: 1px;
  background: var(--border-color);
  margin: 4px 0;
}

.user-link {
  color: var(--accent-primary);
  font-weight: 600;
  text-decoration: none;
}

.user-link:hover {
  text-decoration: underline;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.btn-primary {
  background: var(--accent-primary);
  color: white;
}

.btn-primary:hover {
  background: var(--accent-hover);
}

.btn-secondary {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.btn-secondary:hover {
  background: var(--border-color);
}

.login-modal {
  z-index: 1000;
}

/* PIN Modal Styles (for Header) */
.pin-modal {
  background: var(--bg-secondary);
  border-radius: 12px;
  padding: 0;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 8px 32px var(--shadow-color);
  position: relative;
  z-index: 1001;
}

.pin-modal .modal-header {
  padding: 24px;
  border-bottom: 1px solid var(--border-color);
}

.pin-modal .modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: var(--text-primary);
  font-weight: 700;
}

.pin-modal .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--text-secondary);
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s;
}

.pin-modal .close-btn:hover {
  background: var(--bg-tertiary);
}

.pin-modal form {
  padding: 24px;
}

.pin-modal .error-message {
  background: var(--error-bg);
  color: var(--error-color);
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
}

.pin-modal .form-group {
  margin-bottom: 20px;
}

.pin-modal .pin-input {
  width: 100%;
  padding: 12px 16px;
  font-size: 24px;
  letter-spacing: 8px;
  text-align: center;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  transition: border-color 0.2s;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.pin-modal .pin-input:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.pin-modal .login-btn {
  width: 100%;
  padding: 12px;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.pin-modal .login-btn:hover:not(:disabled) {
  background: var(--accent-hover);
}

.pin-modal .login-btn:disabled {
  background: var(--text-tertiary);
  cursor: not-allowed;
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: var(--text-primary);
  font-weight: 700;
}

.login-modal-content {
  background: var(--bg-secondary);
  padding: 30px;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 20px var(--shadow-color);
}

.modal-tabs {
  display: flex;
  border-bottom: 1px solid var(--border-color);
}

.login-modal-content h3 {
  margin-bottom: 20px;
  color: var(--text-primary);
}

.modal-content {
  padding: 24px;
}

.input {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 1rem;
  margin-bottom: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.input:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.error {
  color: var(--error-color);
  font-size: 0.9rem;
  margin: 10px 0;
}

.modal-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.modal-actions .btn {
  flex: 1 1;
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 10px;
  }

  .nav {
    gap: 10px;
  }

  .nav-link {
    padding: 6px 12px;
    font-size: 0.9rem;
  }

  .logo h1 {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".header {\r\n  background: var(--bg-secondary);\r\n  border-bottom: 1px solid var(--border-color);\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n  box-shadow: 0 1px 3px var(--shadow-color);\r\n}\r\n\r\n.header-container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 0 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  height: 60px;\r\n}\r\n\r\n.logo {\r\n  color: var(--accent-primary);\r\n  font-size: 1.2rem;\r\n  font-weight: bold;\r\n  text-decoration: none;\r\n}\r\n\r\n.logo h1 {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.nav {\r\n  display: flex;\r\n  gap: 20px;\r\n  align-items: center;\r\n}\r\n\r\n.nav-link {\r\n  color: var(--text-primary);\r\n  font-weight: 500;\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.nav-link:hover {\r\n  background: var(--bg-tertiary);\r\n  text-decoration: none;\r\n}\r\n\r\n/* Dropdown Styles */\r\n.dropdown {\r\n  position: relative;\r\n}\r\n\r\n.dropdown-toggle {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.dropdown-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  margin-top: 8px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 16px var(--shadow-color);\r\n  min-width: 150px;\r\n  overflow: hidden;\r\n  z-index: 1000;\r\n}\r\n\r\n.dropdown-item {\r\n  display: block;\r\n  padding: 12px 16px;\r\n  color: var(--text-primary);\r\n  text-decoration: none;\r\n  transition: background 0.2s;\r\n  font-weight: 500;\r\n}\r\n\r\n.dropdown-item:hover {\r\n  background: var(--bg-tertiary);\r\n  text-decoration: none;\r\n}\r\n\r\n.auth-section {\r\n  position: relative;\r\n}\r\n\r\n.user-menu {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n/* Account Dropdown Styles */\r\n.account-dropdown {\r\n  position: relative;\r\n}\r\n\r\n.avatar-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 50%;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.avatar-btn:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.user-avatar {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  border: 2px solid var(--border-color);\r\n}\r\n\r\n.account-dropdown-menu {\r\n  position: absolute;\r\n  top: calc(100% + 8px);\r\n  right: 0;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 16px var(--shadow-color);\r\n  min-width: 200px;\r\n  overflow: hidden;\r\n  z-index: 1000;\r\n}\r\n\r\n.account-dropdown-header {\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.account-dropdown-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  text-align: left;\r\n  font-size: 14px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.account-dropdown-item:hover {\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.account-dropdown-avatar {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.add-account-btn {\r\n  border-top: 1px solid var(--border-color);\r\n  font-weight: 600;\r\n  color: var(--accent-primary);\r\n  justify-content: center;\r\n}\r\n\r\n.add-account-btn:hover {\r\n  background: var(--accent-light);\r\n}\r\n\r\n.account-dropdown-divider {\r\n  height: 1px;\r\n  background: var(--border-color);\r\n  margin: 4px 0;\r\n}\r\n\r\n.user-link {\r\n  color: var(--accent-primary);\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n}\r\n\r\n.user-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.btn {\r\n  padding: 8px 16px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.btn-primary {\r\n  background: var(--accent-primary);\r\n  color: white;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: var(--accent-hover);\r\n}\r\n\r\n.btn-secondary {\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: var(--border-color);\r\n}\r\n\r\n.login-modal {\r\n  z-index: 1000;\r\n}\r\n\r\n/* PIN Modal Styles (for Header) */\r\n.pin-modal {\r\n  background: var(--bg-secondary);\r\n  border-radius: 12px;\r\n  padding: 0;\r\n  max-width: 400px;\r\n  width: 90%;\r\n  box-shadow: 0 8px 32px var(--shadow-color);\r\n  position: relative;\r\n  z-index: 1001;\r\n}\r\n\r\n.pin-modal .modal-header {\r\n  padding: 24px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.pin-modal .modal-header h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  color: var(--text-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.pin-modal .close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  padding: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.pin-modal .close-btn:hover {\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.pin-modal form {\r\n  padding: 24px;\r\n}\r\n\r\n.pin-modal .error-message {\r\n  background: var(--error-bg);\r\n  color: var(--error-color);\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 16px;\r\n  font-size: 14px;\r\n}\r\n\r\n.pin-modal .form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.pin-modal .pin-input {\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  font-size: 24px;\r\n  letter-spacing: 8px;\r\n  text-align: center;\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 8px;\r\n  transition: border-color 0.2s;\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.pin-modal .pin-input:focus {\r\n  outline: none;\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.pin-modal .login-btn {\r\n  width: 100%;\r\n  padding: 12px;\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.pin-modal .login-btn:hover:not(:disabled) {\r\n  background: var(--accent-hover);\r\n}\r\n\r\n.pin-modal .login-btn:disabled {\r\n  background: var(--text-tertiary);\r\n  cursor: not-allowed;\r\n}\r\n\r\n.modal-header {\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.modal-header h2 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  color: var(--text-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.login-modal-content {\r\n  background: var(--bg-secondary);\r\n  padding: 30px;\r\n  border-radius: 12px;\r\n  max-width: 400px;\r\n  width: 90%;\r\n  box-shadow: 0 4px 20px var(--shadow-color);\r\n}\r\n\r\n.modal-tabs {\r\n  display: flex;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.login-modal-content h3 {\r\n  margin-bottom: 20px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.modal-content {\r\n  padding: 24px;\r\n}\r\n\r\n.input {\r\n  width: 100%;\r\n  padding: 12px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  margin-bottom: 10px;\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.input:focus {\r\n  outline: none;\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.error {\r\n  color: var(--error-color);\r\n  font-size: 0.9rem;\r\n  margin: 10px 0;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.modal-actions .btn {\r\n  flex: 1;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .header-container {\r\n    padding: 0 10px;\r\n  }\r\n\r\n  .nav {\r\n    gap: 10px;\r\n  }\r\n\r\n  .nav-link {\r\n    padding: 6px 12px;\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .logo h1 {\r\n    font-size: 1.2rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
